module.exports = ".ulAvisos{height:29vh !important;overflow:auto}\n"